import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from '../mainViewMixin';
import { mapState } from 'vuex';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewNiotaClassicDevicesDevicesList',
  mixins: [mainViewMixin],
  data: function data() {
    return {
      isLoadingAccounts: true,
      selectedAccounts: [],
      deviceTypes: [],
      applications: [],
      selectedRows: [],
      editAllFormDialog: false,
      limit: 1000,
      originator: null,
      firstStep: false,
      secondStep: false,
      thirdStep: false,
      addNew: false,
      datasourceType: null,
      qrScanner: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    headerBG: function headerBG() {
      return './img/consumer.png';
    }
  }),
  mounted: function mounted() {
    this.deviceTypeFetchPlain();
    this.applicationsFetchPlain();
    this.originatorFetchPlain();
  },
  methods: {
    getAccountsIdsFromQueryParams: function getAccountsIdsFromQueryParams() {
      return (this.$route.query.accounts || '').split(',').map(function (i) {
        return parseInt(i, 10);
      });
    },
    deviceTypeFetchPlain: function deviceTypeFetchPlain() {
      var _this = this;

      NiotaClassicApiService.deviceTypeFetchPlain().then(function (res) {
        _this.deviceTypes = res.data.devicetypes;
      }).catch(function () {
        _this.deviceTypes = [];

        _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain: function applicationsFetchPlain() {
      var _this2 = this;

      NiotaClassicApiService.applicationsFetchPlain().then(function (res) {
        _this2.applications = res.data.applications;
      }).catch(function () {
        _this2.applications = [];

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
      });
    },
    originatorFetchPlain: function originatorFetchPlain() {
      var _this3 = this;

      NiotaClassicApiService.originatorsFetchPlain(this.limit).then(function (res) {
        _this3.originators = res.data.originators;
      }).catch(function () {
        _this3.originators = [];

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingOriginators'), 'error');
      });
    },
    getSelectedRows: function getSelectedRows(rows) {
      this.selectedRows = rows;
    },
    editAll: function editAll() {
      this.editAllFormDialog = true;
    },
    closeEditAllForm: function closeEditAllForm() {
      this.editAllFormDialog = false;
    },
    refreshList: function refreshList() {
      var _this4 = this;

      this.selectedRows = [];
      setTimeout(function () {
        _this4.$refs.list.fetchList();
      }, 500);
    },
    selectedApplication: function selectedApplication(application) {
      this.editedItem.applicationId = application.id;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.secondStep = true;
      this.thirdStep = false;
    },
    selectedOriginator: function selectedOriginator(originator) {
      this.editedItem.originatorId = originator.id;
      this.originator = originator;
      this.getDatasourceType();
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.secondStep = false;
      this.thirdStep = true;
    },
    editDevice: function editDevice(item) {
      var originator = this.originators.filter(function (originator) {
        return originator.id === item.originatorId;
      });

      if (originator && originator.length) {
        if (originator[0].datasource) {
          this.datasourceType = originator[0].datasource.type;
        }
      }

      this.editedItem = item;
      this.formDialog = true;
    },
    addDevice: function addDevice() {
      this.editedItem = {};
      this.firstStep = true;
      this.secondStep = false;
      this.thirdStep = false;
    },
    getDatasourceType: function getDatasourceType() {
      this.datasourceType = this.originator.datasource.type;
    },
    resetApplication: function resetApplication() {
      delete this.editedItem.originatorId;
      delete this.editedItem.applicationId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = true;
      this.secondStep = false;
      this.thirdStep = false;
    },
    resetOriginator: function resetOriginator() {
      delete this.editedItem.originatorId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.secondStep = true;
      this.thirdStep = false;
      this.addNew = false;
    },
    csvUpload: function csvUpload() {
      this.$router.push('/niota-classic/devices/csv/upload');
    },
    resetFilter: function resetFilter() {
      this.selectedAccounts = [];
    }
  }
};